import {createContext, useContext, useState} from 'react'
import {css} from '@emotion/react'
import {Outlet} from 'react-router-dom'
import {Drawer} from 'antd'
import MainHeader from './MainHeader'

export const DrawerContext = createContext()
export const useDrawerContext = () => useContext(DrawerContext)

const cssPage = css({
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
})

const MainPage = () => {
    const [drawer, setDrawer] = useState(null)

    const {
        content: drawerContent,
        isOpen: isDrawerOpen = true,
        ...drawerProps
    } = drawer ?? {}

    const onClose = () => {
        setDrawer(drawer => ({...drawer, isOpen: false}))
        drawer?.onClose?.()
    }

    return (
        <div css={cssPage}>
            <DrawerContext.Provider value={setDrawer}>
                <MainHeader />
                <Outlet />
            </DrawerContext.Provider>

            <Drawer
                width="50%"
                {...drawerProps}
                open={drawerContent && isDrawerOpen}
                getContainer={false}
                onClose={onClose}
            >
                {drawerContent}
            </Drawer>
        </div>
    )
}

export default MainPage
